import * as KioskDevices from './devices';

export const KioskDevicesApi = KioskDevices;
